import styled from "styled-components";
import theme from "../../../styles/theme";

import { useEffect } from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { useGetStaticItemSum } from "../../../interface/item";
import { useState } from 'react';
import { NumericFormatCustom } from "../dashboard/common";
import CommonDataGrid from "../../common/CommonDataGrid";
import { useGetCategoryList } from "../../../interface/common";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import ChartStaticInoutItem from "../dashboard/ChartStaticInoutItem";
import { useGetInoutStatic } from "../../../interface/inout";
import { IOT_TP } from "../../common/constants";
import { useGetStaticInspect } from "../../../interface/inspect";
import moment from 'moment';

const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    h3 {
        font-size: ${theme.fontSize.base};
        font-weight: 600;
        margin: 0;
        color: ${theme.color.black};
    }
`;

const staticInspectColumn = [
    { field: 'isp_nm', headerName: '조사명', width:180},
    { field: 'isp_kdnm', headerName: '조사대상', width:120},
    { field: 'isp_stnm', headerName: '조사상태', width:80},
    { field: 'sdate', headerName: '조사기간(시작)', width:120 },
    { field: 'edate', headerName: '조사기간(종료)', width:120 },
    { field: 'isp_tot_cnt', headerName: '조사대상량', width:80},
    { field: 'isp_cnt', headerName: '조사진행량', width:80},
    { field: 'cnt_01', headerName: '정상', width:80},
    { field: 'cnt_02', headerName: '변경', width:80},
    { field: 'cnt_10', headerName: '고장/파손', width:80},
    { field: 'cnt_12', headerName: '분실', width:80},
    { field: 'cnt_20', headerName: '수리중', width:80},
    { field: 'cnt_21', headerName: '임대중', width:80},
    { field: 'cnt_30', headerName: '판매', width:80},
]


const StaticInspect = () => {

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const [cid, setCid] = useState(searchParams.get('cid'));

    const [staticInspetList , setStaticInspectList] = useState([]);
    const [pCatelist, setPCateList] = useState([]);

    const {data: staticInspect, isLoading: staticInspectLoading} = useGetStaticInspect();

    useEffect(()=>{
        if(staticInspect){
            setStaticInspectList(staticInspect.map((item,index)=>({
                                                                    ...item,
                                                                    sdate: item.sdate ? moment(item.sdate).format('YYYY/MM/DD') : '',
                                                                    edate: item.edate ? moment(item.edate).format('YYYY/MM/DD') : '',
                                                                    chart:[{complete:item.isp_tot_cnt>0 ? Math.ceil(item.isp_cnt/item.isp_tot_cnt*100):0}],
                                                                    // chart:[{complete:1}],
                                                                    id:index
                                                                })))
        }
    },[staticInspect])

    const handleRowClick = (param, event) =>{
        navigate('/admin/inspects/'+param.row.sno+'/ispDetail')
    }

    return (
        <MainWrap>
            <h3>자산조사 현황</h3>
            <div style={{height:'8px'}} />
            <div style={{height:'85vh'}}>
            <CommonDataGrid
                    isLoading={staticInspectLoading}
                    list={staticInspetList}
                    columns={staticInspectColumn}
                    onRowClick={handleRowClick}
                    showCount={staticInspetList.length}
                />
            </div>
        </MainWrap>
    )

}

export default StaticInspect;